
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { NiceButton }
})
export default class MediaChooserLayer extends Vue {
  @Prop()
  value: unknown;

  get hasValue() {
    return !!this.value;
  }
}
